import { usePathname, useRouter } from 'expo-router';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { isDesktop } from '@/core';
import { Text } from '@/ui';

import ContactSupport from '../contact-support';
import { NavigationButton, NavigationButtonTypes } from '../navigation-button';

export default function SupportFaq() {
  const { styles, theme } = useStyles(stylesheet);
  const pathname = usePathname();
  const router = useRouter();

  return (
    <View
      style={{
        flex: 1,
        backgroundColor: theme.colors.background_1,
        alignItems: 'center',
      }}
    >
      <View style={styles.container}>
        {isDesktop() ? (
          <View style={{ gap: 16 }}>
            {!pathname.includes('/partner') ? (
              <NavigationButton
                type={NavigationButtonTypes.back_with_text}
                onPress={() => {
                  if (pathname.includes('/partner')) {
                    router.navigate('/partner/more');
                  } else {
                    router.navigate('/account');
                  }
                }}
              />
            ) : null}

            <Text type="largeTitle">Support</Text>
          </View>
        ) : null}

        <ContactSupport style={{ flexGrow: 0 }} />

        {/* <View style={{ gap: 16 }}>
                <Text tx="supportFaq.faq" type="title1" />

                <Card>
                  <MenuItem
                    leftIcon={<QuestionMark />}
                    leftIconFillColor={theme.colors.icon.color}
                    rightIcon={<ArrowRight />}
                    rightIconFillColor={theme.colors.icon.color}
                    tx="legal.rentalTerms"
                    onPress={() => {
                      router.navigate('/account/legal/rental-terms');
                    }}
                  />

                  <MenuItem
                    leftIcon={<QuestionMark />}
                    leftIconFillColor={theme.colors.icon.color}
                    rightIcon={<ArrowRight />}
                    rightIconFillColor={theme.colors.icon.color}
                    tx="legal.rentalTerms"
                    onPress={() => {
                      router.navigate('/account/legal/rental-terms');
                    }}
                  />
                </Card>
              </View> */}
      </View>
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    flexGrow: 1,
    paddingTop: 24,
    paddingLeft: 16,
    paddingRight: 16,
    gap: 16,
    backgroundColor: theme.colors.background_1,
    maxWidth: {
      xs: '100%',
      sm: 600,
      md: 800,
    },
    width: {
      xs: '100%',
      md: 600,
    },
  },
}));
